import {Button, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import dashboard from "../../assets/img/dashboard.png";
import React, {useState} from "react";
import "./WithSubscribe.css"
import {useTranslation} from "react-i18next";
import {useDispatch} from 'react-redux';
import {useNavigate} from "react-router-dom";
import baseHostname from "../../hostname";


const WithAnalyze = () => {
    const {t} = useTranslation();

    const [validated, setValidated] = useState(null);
    const [formState, setFormState] = useState('initial');
    const [isChecked, setIsChecked] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate(); // Hook for programmatic navigation
    function onFormSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(event.target);
        const domain = formData.get("domain");
        const selector = formData.get("selector");

        function getHostname(url) {
            try {
                // If the URL doesn't start with http:// or https://, prepend 'http://'
                if (!/^https?:\/\//i.test(url)) {
                    url = 'http://' + url;
                }
                return new URL(url).hostname;
            } catch (e) {
                console.error(e);
                return ''; // Invalid URL
            }
        }

        const hostname = getHostname(domain.trim());

        if (hostname === '') {
            setValidated(false);
            alert('Please enter your domain');
            return;
        }

        if (!isChecked) {
            setValidated(false);
            alert('You must agree to the terms before proceeding.');
            return;
        }

        setValidated(true);
        setFormState('loading');

        fetch(
            baseHostname + '/index.php/domain/analyze/' + hostname + (selector === "" ? "" : ("/" + selector)),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then(response => {
                if (!response.ok) {
                    console.warn('Server returned an error:', response.status);
                    setFormState('error');
                    return null;
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    // Save the DMARC validation result into Redux
                    dispatch({type: 'SET_VALIDATION_RESULT', payload: data});
                    setFormState('success');
                    resetForm();
                    // Redirect to the results page
                    navigate('/analyze-results');
                }
            })
            .catch(error => {
                console.error('Error during API call:', error);
                setFormState('error');
                resetForm();
            });
    }

    function resetForm() {
        setTimeout(
            () => {
                setFormState('initial')
            },
            5000
        )
    }


    return (
        <Container fluid className="min-vh-100 d-flex flex-column overflow-hidden ps-3 pe-3 mt-3">
            <Row className="align-items-center text-center text-lg-start min-vh-100">
                <Col lg={"6"} className={"px-lg-5"}>
                    <h1 className="display-4 fw-bold text-uppercase"
                        dangerouslySetInnerHTML={{__html: t("pages.home.hero.withAnalyze.title")}}>
                    </h1>
                    <p className="mt-4">
                        {t("pages.home.hero.withAnalyze.subTitle")}
                    </p>
                    <Form className="d-flex gap-2 mt-4 flex-column" validated={validated} onSubmit={onFormSubmit}>
                        <div className="text-primary">
                            {t("pages.home.hero.withAnalyze.ctaInfo")}
                        </div>
                        <InputGroup>
                            <Form.Control
                                aria-label="Large"
                                type="text"
                                placeholder={t("pages.home.hero.withAnalyze.form.domain.placeholder")}
                                aria-describedby="inputGroup-sizing-sm"
                                name="domain"
                                disabled={!isChecked}
                                required={true}
                            />
                        </InputGroup>
                        <InputGroup size="sm">
                            <Form.Control
                                aria-label="Large"
                                type="text"
                                placeholder={t("pages.home.hero.withAnalyze.form.selector.placeholder")}
                                aria-describedby="inputGroup-sizing-sm"
                                disabled={!isChecked}
                                name="selector"
                            />
                        </InputGroup>
                        <InputGroup className={"align-self-stretch input-group d-flex flex-grow-1 flex-column"}>
                            <Button type="submit" className={"text-white"}>{t("pages.home.hero.withAnalyze.form.button.text")}</Button>
                        </InputGroup>
                        <Form.Group controlId="formBasicCheckbox" className="mt-2">
                            <Form.Check
                                type="checkbox"
                                label={<span>I agree to the <a href="/terms-and-conditions" target="_blank"
                                                               rel="noopener noreferrer">terms and conditions</a></span>}
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                                required={true}
                            />
                        </Form.Group>
                    </Form>
                </Col>
                <Col lg="6" className="text-center mt-5">
                    <img src={dashboard} alt="dashboard" className="img-fluid rounded shadow"/>
                </Col>
            </Row>
        </Container>
    );
}

export default WithAnalyze;
